"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCustomerReferral = void 0;
const getCustomerReferral = (referral, referralCode, consultantNumber) => {
  if (!referral) {
    return undefined;
  }
  if (referral.sponsorId === 0) {
    return {
      ReferralType: 'InternationalPbs',
      InternationalPbsCode: referralCode
    };
  }
  const referralType = referral.referralType === 'Mgm' ? 'ReferralLink' : referral.referralType;
  return {
    ReferralType: referralType,
    ConsultantNumber: consultantNumber,
    CustomerId: referral.sponsorId
  };
};
exports.getCustomerReferral = getCustomerReferral;